export enum DigAttribute {
  Spectacular = 886,
  FreeBall = 887,
}
